var _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReinstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Re-continue",
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.402,
    height: 22,
    viewBox: "0 0 95.402 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Reinstate",
    transform: "translate(24.402 17)",
    fill: "#307349",
    fontSize: 16,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Reinstate"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "update_FILL0_wght400_GRAD0_opsz48",
    d: "M128.3,232.523a8.016,8.016,0,0,1-3.223-.654,8.507,8.507,0,0,1-2.64-1.779,8.308,8.308,0,0,1-1.783-2.639,8.1,8.1,0,0,1-.651-3.236,7.939,7.939,0,0,1,.651-3.213,8.243,8.243,0,0,1,1.783-2.6,8.443,8.443,0,0,1,2.64-1.756A8.139,8.139,0,0,1,128.3,216a7.751,7.751,0,0,1,3.463.8,8.7,8.7,0,0,1,2.823,2.2v-2.433h1.372v4.773h-4.778V219.97h2.4a7.954,7.954,0,0,0-2.366-1.882,6.2,6.2,0,0,0-2.915-.711,6.8,6.8,0,0,0-4.892,1.962,6.421,6.421,0,0,0-2.035,4.808,6.8,6.8,0,0,0,2.012,4.957,6.635,6.635,0,0,0,4.915,2.042,6.47,6.47,0,0,0,4.823-2.02,6.751,6.751,0,0,0,1.966-4.888h1.372a8.061,8.061,0,0,1-2.377,5.864A7.8,7.8,0,0,1,128.3,232.523Z",
    transform: "translate(-120 -213.262)",
    fill: "#307349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinstate);
export default __webpack_public_path__ + "static/media/reinstate.2cd1263c745b22f84f7867ed5b0e4a26.svg";
export { ForwardRef as ReactComponent };